// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__I4APe","rootSmall":"AddTileButton_rootSmall__1ryXl"};